module.exports = __webpack_public_path__ + "static/Flavor_18AMT90228-b011c3eb6b761c21d2769eebe9ab0019.pdf";